import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import './app-dashboard.css';
import RoutingService from '../../services/RoutingService';
import HeaderBreadcrumb from '../../components/header-breadcrumb/HeaderBreadcrumb';

const RS = new RoutingService();

class AppDashboard extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			appStuff: 'Dashboard metrics go here for ' + RS.getCurrentApplication()
		};
	}

	render() {
		return (
			<div className="app-dashboard-view animated fadeIn">
				<HeaderBreadcrumb currentPage="Dashboard" />
				<div>{this.data.appStuff}</div>
			</div>
		);
	}
}

export default AppDashboard;



// WEBPACK FOOTER //
// ./src/views/app-dashboard/AppDashboard.js